import React, { useMemo } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import { fmtPrice } from "./homesUtil";

const priceIcon = (label, rent) =>
  L.divIcon({
    className: "hp-price-pin",
    html: `<span style="display:inline-block;white-space:nowrap;background:${rent ? "#0F172A" : "#2563EB"};color:#fff;font-weight:800;font-size:12px;padding:4px 8px;border-radius:999px;box-shadow:0 2px 6px rgba(0,0,0,.35);border:2px solid #fff">${label}</span>`,
    iconSize: [10, 10],
    iconAnchor: [20, 12],
  });

const compact = (n) => {
  if (n == null) return "?";
  if (n >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1000) return `$${Math.round(n / 1000)}K`;
  return `$${n}`;
};

function FitBounds({ points, singlePin, zoom }) {
  const map = useMap();
  React.useEffect(() => {
    if (!points.length) return;
    if (singlePin || points.length === 1) {
      map.setView([points[0].lat, points[0].lng], zoom || 13);
      return;
    }
    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 13 });
  }, [map, points, singlePin, zoom]);
  return null;
}

export function ListingMap({ points = [], center, zoom = 11, height = 420, singlePin = false }) {
  const valid = useMemo(() => points.filter((p) => p.lat != null && p.lng != null), [points]);
  const mapCenter = center || (valid[0] ? [valid[0].lat, valid[0].lng] : [39.5, -98.35]);

  return (
    <div className="overflow-hidden rounded-2xl border border-[#0F172A]/10" style={{ height }} data-testid="listing-map">
      <MapContainer center={mapCenter} zoom={valid.length ? zoom : 4} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={valid} singlePin={singlePin} zoom={singlePin ? zoom : undefined} />
        {valid.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lng]} icon={priceIcon(singlePin ? "Here" : compact(p.price), p.rent)}>
            <Popup>
              <div style={{ minWidth: 150 }}>
                <div style={{ fontWeight: 800, color: "#0F172A" }}>{fmtPrice(p.price, p.rent)}</div>
                <div style={{ fontSize: 12 }}>{p.address}</div>
                {!singlePin && (
                  <Link to={`/homes/property/${p.id}`} style={{ color: "#2563EB", fontWeight: 700, fontSize: 12 }}>View details →</Link>
                )}
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
